import styled, { css } from 'styled-components';

export const DayDisplayWrapper = styled.div<{ $isToday: boolean }>`
  display: flex;
  width: fit-content;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;

  ${({ $isToday, theme }) =>
    $isToday &&
    css`
      border-radius: 8px;
      border: 1px solid ${theme.colors.green4};
      background: ${theme.colors.green1};
    `};
`;

export const DayTitle = styled.span`
  align-self: stretch;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const IconWrapper = styled.div`
  display: flex;
  padding: 8px 0px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

export const MultiplierText = styled.span<{ $isCompleted?: boolean; $isToday?: boolean }>`
  color: ${({ theme }) => theme.colors.black6};
  ${({ $isToday }) =>
    $isToday &&
    css`
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.2px;
      min-height: 20px;
      color: ${({ theme }) => theme.colors.black9};
    `}
  ${({ $isCompleted }) =>
    $isCompleted &&
    css`
      color: ${({ theme }) => theme.colors.green7};
    `}
`;
